<template>
  <div class="mt-5">
    <Navbar />    
    <Section title="What is BEX?" small-text="" component-name="WhatBEX" />
    <Section title="Why BEX?" small-text="" component-name="WhyBEX" />
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from '../components/Navbar.vue'
import Section from '../components/Section.vue'
import Footer from '../components/Footer.vue'

export default {
  name: 'About',
  components: {
    Navbar,    
    Section,
    Footer
  }
}
</script>